webpackJsonp([1],{

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LexApp__ = __webpack_require__(204);






new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#lex-app',
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
  template: '<LexApp/>',
  components: { LexApp: __WEBPACK_IMPORTED_MODULE_2__LexApp__["a" /* default */] }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.errorHandler = function (err, vm, info) {
  console.error('unhandled error in lex-app', err, vm, info);
};

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_LexWeb__ = __webpack_require__(149);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'LexWeb',
    component: __WEBPACK_IMPORTED_MODULE_2_components_LexWeb__["a" /* default */]
  }]
}));

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LexWeb_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4973da9d_node_modules_vue_loader_lib_selector_type_template_index_0_LexWeb_vue__ = __webpack_require__(203);
function injectStyle (ssrContext) {
  __webpack_require__(150)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LexWeb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4973da9d_node_modules_vue_loader_lib_selector_type_template_index_0_LexWeb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Page__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToolbarContainer__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageList__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatusBar__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputContainer__ = __webpack_require__(183);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lex-web',
  components: {
    Page: __WEBPACK_IMPORTED_MODULE_0__Page__["a" /* default */],
    ToolbarContainer: __WEBPACK_IMPORTED_MODULE_1__ToolbarContainer__["a" /* default */],
    MessageList: __WEBPACK_IMPORTED_MODULE_2__MessageList__["a" /* default */],
    StatusBar: __WEBPACK_IMPORTED_MODULE_3__StatusBar__["a" /* default */],
    InputContainer: __WEBPACK_IMPORTED_MODULE_4__InputContainer__["a" /* default */]
  },
  computed: {
    initialSpeechInstruction: function initialSpeechInstruction() {
      return this.$store.state.config.lex.initialSpeechInstruction;
    },
    initialText: function initialText() {
      return this.$store.state.config.lex.initialText;
    },
    textInputPlaceholder: function textInputPlaceholder() {
      return this.$store.state.config.ui.textInputPlaceholder;
    },
    toolbarColor: function toolbarColor() {
      return this.$store.state.config.ui.toolbarColor;
    },
    toolbarTitle: function toolbarTitle() {
      return this.$store.state.config.ui.toolbarTitle;
    },
    toolbarLogo: function toolbarLogo() {
      return this.$store.state.config.ui.toolbarLogo;
    },
    isUiMinimized: function isUiMinimized() {
      return this.$store.state.isUiMinimized;
    }
  },
  methods: {
    toggleMinimizeUi: function toggleMinimizeUi() {
      return this.$store.dispatch('toggleIsUiMinimized');
    }
  }
});

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__ = __webpack_require__(154);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page',
  render: function render() {
    var headElem = document.querySelector('head');

    var favIconElem = document.createElement('link');
    favIconElem.setAttribute('rel', 'fav icon');
    favIconElem.setAttribute('href', this.$store.state.config.ui.favIcon);
    headElem.appendChild(favIconElem);

    var titleElem = document.createElement('title');
    titleElem.textContent = this.$store.state.config.ui.pageTitle;
    headElem.appendChild(titleElem);
  }
});

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToolbarContainer_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f58ea4_node_modules_vue_loader_lib_selector_type_template_index_0_ToolbarContainer_vue__ = __webpack_require__(157);
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToolbarContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f58ea4_node_modules_vue_loader_lib_selector_type_template_index_0_ToolbarContainer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toolbar-container',
  props: ['toolbarTitle', 'toolbarColor', 'toolbarLogo', 'isUiMinimized'],
  computed: {
    toolTipMinimize: function toolTipMinimize() {
      return {
        html: this.isUiMinimized ? 'maximize' : 'minimize'
      };
    }
  },
  methods: {
    toggleMinimize: function toggleMinimize() {
      this.$emit('toggleMinimizeUi');
    }
  }
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    class: _vm.toolbarColor,
    attrs: {
      "dark": "",
      "dense": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.toolbarLogo
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "hidden-xs-and-down"
  }, [_vm._v("\n    " + _vm._s(_vm.toolbarTitle) + "\n  ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.$store.state.isRunningEmbedded) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: (_vm.toolTipMinimize),
      expression: "toolTipMinimize",
      arg: "left"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMinimize($event)
      }
    }
  }, [_c('v-icon', [_vm._v("\n      " + _vm._s(_vm.isUiMinimized ? 'arrow_drop_up' : 'arrow_drop_down') + "\n    ")])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b8f18d_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__ = __webpack_require__(173);
function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20b8f18d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b8f18d_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(161);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'message-list',
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_0__Message__["a" /* default */]
  },
  computed: {
    messages: function messages() {
      return this.$store.state.messages;
    }
  },
  watch: {
    messages: function messages() {
      var _this = this;

      this.$nextTick(function () {
        _this.$el.scrollTop = _this.$el.scrollHeight;
      });
    }
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290c8f4f_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__ = __webpack_require__(172);
function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-290c8f4f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290c8f4f_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MessageText__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResponseCard__ = __webpack_require__(168);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'message',
  props: ['message'],
  components: {
    MessageText: __WEBPACK_IMPORTED_MODULE_0__MessageText__["a" /* default */],
    ResponseCard: __WEBPACK_IMPORTED_MODULE_1__ResponseCard__["a" /* default */]
  },
  computed: {
    botDialogState: function botDialogState() {
      if (!('dialogState' in this.message)) {
        return null;
      }
      switch (this.message.dialogState) {
        case 'Failed':
          return { icon: 'error', color: 'red' };
        case 'Fulfilled':
        case 'ReadyForFulfillment':
          return { icon: 'done', color: 'green' };
        default:
          return null;
      }
    },
    shouldDisplayResponseCard: function shouldDisplayResponseCard() {
      return this.message.responseCard && (this.message.responseCard.version === '1' || this.message.responseCard.version === 1) && this.message.responseCard.contentType === 'application/vnd.amazonaws.card.generic' && 'genericAttachments' in this.message.responseCard && this.message.responseCard.genericAttachments instanceof Array;
    }
  },
  methods: {
    playAudio: function playAudio() {
      var audioElem = this.$el.querySelector('audio');
      if (audioElem) {
        audioElem.play();
      }
    }
  }
});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageText_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d69cb2c8_node_modules_vue_loader_lib_selector_type_template_index_0_MessageText_vue__ = __webpack_require__(167);
function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d69cb2c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d69cb2c8_node_modules_vue_loader_lib_selector_type_template_index_0_MessageText_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'message-text',
  props: ['message'],
  computed: {
    shouldConvertUrlToLinks: function shouldConvertUrlToLinks() {
      return this.$store.state.config.ui.convertUrlToLinksInBotMessages;
    },
    shouldStripTags: function shouldStripTags() {
      return this.$store.state.config.ui.stripTagsFromBotMessages;
    },
    shouldRenderAsHtml: function shouldRenderAsHtml() {
      return this.message.type === 'bot' && this.shouldConvertUrlToLinks;
    },
    botMessageAsHtml: function botMessageAsHtml() {
      var messageText = this.stripTagsFromMessage(this.message.text);
      var messageWithLinks = this.botMessageWithLinks(messageText);
      return messageWithLinks;
    }
  },
  methods: {
    encodeAsHtml: function encodeAsHtml(value) {
      return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
    botMessageWithLinks: function botMessageWithLinks(messageText) {
      var _this = this;

      var linkReplacers = [{
        type: 'web',
        regex: new RegExp('\\b((?:https?://\\w{1}|www\\.)(?:[\\w-.]){2,256}' + '(?:[\\w._~:/?#@!$&()*+,;=[\'\\]-]){0,256})', 'im'),
        replace: function replace(item) {
          var url = !/^https?:\/\//.test(item) ? 'http://' + item : item;
          return '<a target="_blank" ' + ('href="' + encodeURI(url) + '">' + _this.encodeAsHtml(item) + '</a>');
        }
      }];

      return linkReplacers.reduce(function (message, replacer) {
        return message.split(replacer.regex).reduce(function (messageAccum, item, index, array) {
          var messageResult = '';
          if (index % 2 === 0) {
            var urlItem = index + 1 === array.length ? '' : replacer.replace(array[index + 1]);
            messageResult = '' + _this.encodeAsHtml(item) + urlItem;
          }
          return messageAccum + messageResult;
        }, '');
      }, messageText);
    },
    stripTagsFromMessage: function stripTagsFromMessage(messageText) {
      var doc = document.implementation.createHTMLDocument('').body;
      doc.innerHTML = messageText;
      return doc.textContent || doc.innerText || '';
    }
  }
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message.text && _vm.message.type === 'human') ? _c('div', {
    staticClass: "message-text"
  }, [_vm._v("\n  " + _vm._s(_vm.message.text) + "\n")]) : (_vm.message.text && _vm.shouldRenderAsHtml) ? _c('div', {
    staticClass: "message-text",
    domProps: {
      "innerHTML": _vm._s(_vm.botMessageAsHtml)
    }
  }) : (_vm.message.text && _vm.message.type === 'bot') ? _c('div', {
    staticClass: "message-text"
  }, [_vm._v("\n  " + _vm._s((_vm.shouldStripTags) ? _vm.stripTagsFromMessage(_vm.message.text) : _vm.message.text) + "\n")]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponseCard_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_799b9a4e_node_modules_vue_loader_lib_selector_type_template_index_0_ResponseCard_vue__ = __webpack_require__(171);
function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-799b9a4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponseCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_799b9a4e_node_modules_vue_loader_lib_selector_type_template_index_0_ResponseCard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'response-card',
  props: ['response-card'],
  data: function data() {
    return {
      hasButtonBeenClicked: false
    };
  },

  computed: {},
  methods: {
    onButtonClick: function onButtonClick(value) {
      this.hasButtonBeenClicked = true;
      var message = {
        type: 'human',
        text: value
      };

      this.$store.dispatch('postTextMessage', message);
    }
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.responseCard.title.trim()) ? _c('v-card-title', {
    staticClass: "red lighten-5",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.responseCard.title))])]) : _vm._e(), _vm._v(" "), (_vm.responseCard.subTitle) ? _c('v-card-text', [_c('span', [_vm._v(_vm._s(_vm.responseCard.subTitle))])]) : _vm._e(), _vm._v(" "), (_vm.responseCard.imageUrl) ? _c('v-card-media', {
    attrs: {
      "src": _vm.responseCard.imageUrl,
      "contain": "",
      "height": "33vh"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.responseCard.buttons), function(button, index) {
    return _c('v-card-actions', {
      key: index,
      staticClass: "button-row",
      attrs: {
        "actions": ""
      }
    }, [(button.text && button.value) ? _c('v-btn', {
      attrs: {
        "disabled": _vm.hasButtonBeenClicked,
        "default": ""
      },
      nativeOn: {
        "~click": function($event) {
          _vm.onButtonClick(button.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(button.text) + "\n    ")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.responseCard.attachmentLinkUrl) ? _c('v-card-actions', [_c('v-btn', {
    staticClass: "red lighten-5",
    attrs: {
      "flat": "",
      "tag": "a",
      "href": _vm.responseCard.attachmentLinkUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n      Open Link\n    ")])], 1) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('v-chip', [('text' in _vm.message && _vm.message.text !== null && _vm.message.text.length) ? _c('message-text', {
    attrs: {
      "message": _vm.message
    }
  }) : _vm._e(), _vm._v(" "), (_vm.message.type === 'human' && _vm.message.audio) ? _c('div', [_c('audio', [_c('source', {
    attrs: {
      "src": _vm.message.audio,
      "type": "audio/wav"
    }
  })]), _vm._v(" "), _c('v-btn', {
    staticClass: "black--text",
    attrs: {
      "left": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.playAudio($event)
      }
    }
  }, [_c('v-icon', {
    staticClass: "play-button"
  }, [_vm._v("play_circle_outline")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.message.type === 'bot' && _vm.botDialogState) ? _c('v-icon', {
    class: _vm.botDialogState.color + '--text',
    attrs: {
      "medium": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.botDialogState.icon) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.shouldDisplayResponseCard) ? _c('div', {
    staticClass: "response-card"
  }, _vm._l((_vm.message.responseCard.genericAttachments), function(card, index) {
    return _c('response-card', {
      key: index,
      attrs: {
        "response-card": card
      }
    })
  })) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "message-list"
  }, _vm._l((_vm.messages), function(message) {
    return _c('message', {
      key: message.id,
      class: ("message-" + (message.type)),
      attrs: {
        "message": message
      }
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBar_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df12d09_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBar_vue__ = __webpack_require__(182);
function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2df12d09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df12d09_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(65);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'status-bar',
  data: function data() {
    return {
      volume: 0,
      volumeIntervalId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isSpeechConversationGoing: function isSpeechConversationGoing() {
      return this.isConversationGoing;
    },
    isProcessing: function isProcessing() {
      return this.isSpeechConversationGoing && !this.isRecording && !this.isBotSpeaking;
    },
    statusText: function statusText() {
      if (this.isInterrupting) {
        return 'Interrupting...';
      }
      if (this.canInterruptBotPlayback) {
        return 'Say "skip" and I\'ll listen for your answer...';
      }
      if (this.isMicMuted) {
        return 'Microphone seems to be muted...';
      }
      if (this.isRecording) {
        return 'Listening...';
      }
      if (this.isBotSpeaking) {
        return 'Playing audio...';
      }
      if (this.isSpeechConversationGoing) {
        return 'Processing...';
      }
      if (this.isRecorderSupported) {
        return 'Type or click on the mic';
      }
      return '';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['canInterruptBotPlayback', 'isBotSpeaking', 'isConversationGoing', 'isLexInterrupting', 'isLexProcessing', 'isMicMuted', 'isMicQuiet', 'isRecorderSupported', 'isRecording'])),
  methods: {
    enterMeter: function enterMeter() {
      var _this = this;

      var intervalTime = 50;
      var max = 0;
      this.volumeIntervalId = setInterval(function () {
        _this.volume = _this.$store.state.recorder.volume.instant.toFixed(4);
        max = Math.max(_this.volume, max);
      }, intervalTime);
    },
    leaveMeter: function leaveMeter() {
      if (this.volumeIntervalId) {
        clearInterval(this.volumeIntervalId);
      }
    }
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-bar white"
  }, [_c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "status-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.statusText))])]), _vm._v(" "), _c('div', {
    staticClass: "voice-controls"
  }, [_c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.enterMeter,
      "leave": _vm.leaveMeter
    }
  }, [(_vm.isRecording) ? _c('div', {
    staticClass: "ml-2 volume-meter"
  }, [_c('meter', {
    attrs: {
      "value": _vm.volume,
      "min": "0.0001",
      "low": "0.005",
      "optimum": "0.04",
      "high": "0.07",
      "max": "0.09"
    }
  })]) : _vm._e()])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputContainer_vue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd14e82_node_modules_vue_loader_lib_selector_type_template_index_0_InputContainer_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dd14e82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd14e82_node_modules_vue_loader_lib_selector_type_template_index_0_InputContainer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 184:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(65);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-container',
  data: function data() {
    return {
      textInput: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    micButtonIcon: function micButtonIcon() {
      if (this.isMicMuted) {
        return 'mic_off';
      }
      if (this.isBotSpeaking) {
        return 'stop';
      }
      return 'mic';
    },
    isMicButtonDisabled: function isMicButtonDisabled() {
      return this.isMicMuted;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isBotSpeaking', 'isConversationGoing', 'isMicMuted', 'isRecorderSupported'])),
  props: ['textInputPlaceholder', 'initialSpeechInstruction', 'initialText'],
  methods: {
    postTextMessage: function postTextMessage() {
      if (!this.textInput.length) {
        return;
      }
      var message = {
        type: 'human',
        text: this.textInput
      };

      this.$store.dispatch('postTextMessage', message);
      this.textInput = '';
    },
    onMicClick: function onMicClick() {
      if (!this.isConversationGoing) {
        this.startSpeechConversation();
      } else if (this.isBotSpeaking) {
        this.$store.dispatch('interruptSpeechConversation');
      }
    },
    startSpeechConversation: function startSpeechConversation() {
      var _this = this;

      if (this.isMicMuted) {
        return;
      }

      this.setAutoPlay();

      this.playInitialInstruction().then(function () {
        return _this.$store.dispatch('startConversation');
      }).catch(function (error) {
        console.error('error in startSpeechConversation', error);
        _this.$store.dispatch('pushErrorMessage', 'I couldn\'t start the conversation. Please try again. (' + error + ')');
      });
    },
    playInitialInstruction: function playInitialInstruction() {
      var _this2 = this;

      var isInitialState = ['', 'Fulfilled', 'Failed'].some(function (initialState) {
        return _this2.$store.state.lex.dialogState === initialState;
      });

      return isInitialState ? this.$store.dispatch('pollySynthesizeSpeech', this.initialSpeechInstruction) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    setAutoPlay: function setAutoPlay() {
      if (!this.$store.state.botAudio.autoPlay) {
        this.$store.state.botAudio.audio.play();
        this.$store.commit('setAudioAutoPlay', true);
      }
    }
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-container white"
  }, [_c('v-text-field', {
    staticClass: "black--text ml-2",
    attrs: {
      "id": "text-input",
      "name": "text-input",
      "label": _vm.textInputPlaceholder,
      "single-line": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.stopPropagation();
        _vm.postTextMessage($event)
      }
    },
    model: {
      value: (_vm.textInput),
      callback: function($$v) {
        _vm.textInput = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "textInput"
    }
  }), _vm._v(" "), (_vm.isRecorderSupported) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'click to use voice'
      }),
      expression: "{html: 'click to use voice'}",
      arg: "left"
    }],
    staticClass: "black--text mic-button",
    attrs: {
      "icon": "",
      "disabled": _vm.isMicButtonDisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.onMicClick($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v(_vm._s(_vm.micButtonIcon))])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lex-web"
    }
  }, [_c('page'), _vm._v(" "), _c('toolbar-container', {
    attrs: {
      "toolbar-title": _vm.toolbarTitle,
      "toolbar-color": _vm.toolbarColor,
      "toolbar-logo": _vm.toolbarLogo,
      "is-ui-minimized": _vm.isUiMinimized
    },
    on: {
      "toggleMinimizeUi": _vm.toggleMinimizeUi
    }
  }), _vm._v(" "), _c('message-list'), _vm._v(" "), _c('status-bar'), _vm._v(" "), _c('input-container', {
    attrs: {
      "text-input-placeholder": _vm.textInputPlaceholder,
      "initial-text": _vm.initialText,
      "initial-speech-instruction": _vm.initialSpeechInstruction
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LexApp_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3b7c83_node_modules_vue_loader_lib_selector_type_template_index_0_LexApp_vue__ = __webpack_require__(433);
function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var normalizeComponent = __webpack_require__(6)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LexApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3b7c83_node_modules_vue_loader_lib_selector_type_template_index_0_LexApp_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 205:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(208);







__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lex-app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  beforeMount: function beforeMount() {
    if (!this.$route.query.embed) {
      console.info('running in standalone mode');
      this.$store.commit('setIsRunningEmbedded', false);
      this.$store.commit('setAwsCredsProvider', 'cognito');
    } else {
      console.info('running in embedded mode from URL: ', location.href);
      console.info('referrer (possible parent) URL: ', document.referrer);
      console.info('config parentOrigin:', this.$store.state.config.ui.parentOrigin);
      if (!document.referrer.startsWith(this.$store.state.config.ui.parentOrigin)) {
        console.warn('referrer origin: [%s] does not match configured parent origin: [%s]', document.referrer, this.$store.state.config.ui.parentOrigin);
      }

      window.addEventListener('message', this.messageHandler, false);
      this.$store.commit('setIsRunningEmbedded', true);
      this.$store.commit('setAwsCredsProvider', 'parentWindow');
    }

    this.$store.commit('setUrlQueryParams', this.$route.query);
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$store.dispatch('initCredentials'), this.$store.dispatch('initRecorder'), this.$store.dispatch('initBotAudio'), this.$store.dispatch('getConfigFromParent').then(function (config) {
      return _this.$store.dispatch('initConfig', config);
    })]).then(function () {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this.$store.dispatch('initMessageList'), _this.$store.dispatch('initPollyClient'), _this.$store.dispatch('initLexClient')]);
    }).then(function () {
      return _this.$store.state.isRunningEmbedded ? _this.$store.dispatch('sendMessageToParentWindow', { event: 'ready' }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }).catch(function (error) {
      console.error('could not initialize application while mounting:', error);
    });
  },

  methods: {
    messageHandler: function messageHandler(evt) {
      if (evt.origin !== this.$store.state.config.ui.parentOrigin) {
        console.warn('ignoring event - invalid origin:', evt.origin);
        return;
      }
      if (!evt.ports) {
        console.warn('postMessage not sent over MessageChannel', evt);
        return;
      }
      switch (evt.data.event) {
        case 'ping':
          console.info('pong - ping received from parent');
          evt.ports[0].postMessage({
            event: 'resolve',
            type: evt.data.event
          });
          break;

        case 'parentReady':
          evt.ports[0].postMessage({ event: 'resolve', type: evt.data.event });
          break;
        case 'toggleMinimizeUi':
          this.$store.dispatch('toggleIsUiMinimized').then(function () {
            evt.ports[0].postMessage({ event: 'resolve', type: evt.data.event });
          });
          break;
        case 'postText':
          if (!evt.data.message) {
            evt.ports[0].postMessage({
              event: 'reject',
              type: evt.data.event,
              error: 'missing message field'
            });
            return;
          }

          this.$store.dispatch('postTextMessage', { type: 'human', text: evt.data.message }).then(function () {
            evt.ports[0].postMessage({ event: 'resolve', type: evt.data.event });
          });
          break;
        default:
          console.warn('unknown message in messageHanlder', evt);
          break;
      }
    }
  }
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_aws_sdk_clients_polly__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_aws_sdk_clients_polly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_aws_sdk_clients_polly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_lex_client__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_lex_recorder__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__recorder_handlers__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_silent_ogg__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_silent_ogg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_silent_ogg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_silent_mp3__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_silent_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_silent_mp3__);

















__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default.a.config.region = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].region;

var lexClient = new __WEBPACK_IMPORTED_MODULE_7__lib_lex_client__["a" /* default */]({
  botName: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].lex.botName,
  botAlias: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].lex.botAlias,
  region: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].region
});

var pollyClient = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].recorder.enable ? new __WEBPACK_IMPORTED_MODULE_6_aws_sdk_clients_polly___default.a() : null;

var recorder = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].recorder.enable ? new __WEBPACK_IMPORTED_MODULE_8__lib_lex_recorder__["a" /* default */](__WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].recorder) : null;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  strict: "production" === 'development',
  state: {
    lex: {
      acceptFormat: 'audio/ogg',
      dialogState: '',
      isInterrupting: false,
      isProcessing: false,
      inputTranscript: '',
      intentName: '',
      message: '',
      responseCard: null,
      sessionAttributes: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].lex.sessionAttributes,
      slotToElicit: '',
      slots: {}
    },
    messages: [],
    polly: {
      outputFormat: 'ogg_vorbis',
      voiceId: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].polly.voiceId
    },
    botAudio: {
      audio: new Audio(),
      canInterrupt: false,
      interruptIntervalId: null,
      autoPlay: false,
      isInterrupting: false,
      isSpeaking: false
    },

    recorder: recorder,
    recState: {
      isConversationGoing: false,
      isInterrupting: false,
      isMicMuted: false,
      isMicQuiet: true,
      isRecorderSupported: false,
      isRecorderEnabled: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].recorder.enable,
      isRecording: false,
      silentRecordingCount: 0
    },

    isRunningEmbedded: false,
    isUiMinimized: false,
    urlQueryParams: {},
    config: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */],

    awsCreds: {
      provider: 'cognito',
      identityId: null
    }
  },

  getters: {
    canInterruptBotPlayback: function canInterruptBotPlayback(state) {
      return state.botAudio.canInterrupt;
    },
    isBotSpeaking: function isBotSpeaking(state) {
      return state.botAudio.isSpeaking;
    },
    isConversationGoing: function isConversationGoing(state) {
      return state.recState.isConversationGoing;
    },
    isLexInterrupting: function isLexInterrupting(state) {
      return state.lex.isInterrupting;
    },
    isLexProcessing: function isLexProcessing(state) {
      return state.lex.isProcessing;
    },
    isMicMuted: function isMicMuted(state) {
      return state.recState.isMicMuted;
    },
    isMicQuiet: function isMicQuiet(state) {
      return state.recState.isMicQuiet;
    },
    isRecorderSupported: function isRecorderSupported(state) {
      return state.recState.isRecorderSupported;
    },
    isRecording: function isRecording(state) {
      return state.recState.isRecording;
    }
  },

  mutations: {
    setIsMicMuted: function setIsMicMuted(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setIsMicMuted status not boolean', bool);
        return;
      }
      if (state.config.recorder.useAutoMuteDetect) {
        state.recState.isMicMuted = bool;
      }
    },
    setIsMicQuiet: function setIsMicQuiet(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setIsMicQuiet status not boolean', bool);
        return;
      }
      state.recState.isMicQuiet = bool;
    },
    setIsBotSpeaking: function setIsBotSpeaking(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setIsBotSpeaking status not boolean', bool);
        return;
      }
      state.botAudio.isSpeaking = bool;
    },
    setIsLexProcessing: function setIsLexProcessing(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setIsLexProcessing status not boolean', bool);
        return;
      }
      state.lex.isProcessing = bool;
    },
    setIsConversationGoing: function setIsConversationGoing(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setIsConversationGoing status not boolean', bool);
        return;
      }
      state.recState.isConversationGoing = bool;
    },
    setAudioAutoPlay: function setAudioAutoPlay(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setAudioAutoPlay status not boolean', bool);
        return;
      }
      state.botAudio.autoPlay = bool;
    },
    startRecording: function startRecording(state) {
      console.info('start recording');
      if (state.recState.isRecording === false) {
        state.recorder.start();
        state.recState.isRecording = true;
      }
    },
    stopRecording: function stopRecording(state) {
      if (state.recState.isRecording === true) {
        state.recState.isRecording = false;
      }
    },
    pushMessage: function pushMessage(state, message) {
      state.messages.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        id: state.messages.length
      }, message));
    },
    updateLexState: function updateLexState(state, lexState) {
      state.lex = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.lex, lexState);
    },
    increaseSilentRecordingCount: function increaseSilentRecordingCount(state) {
      state.recState.silentRecordingCount += 1;
    },
    resetSilentRecordingCount: function resetSilentRecordingCount(state) {
      state.recState.silentRecordingCount = 0;
    },
    setAudioContentType: function setAudioContentType(state, type) {
      switch (type) {
        case 'mp3':
        case 'mpg':
        case 'mpeg':
          state.polly.outputFormat = 'mp3';
          state.lex.acceptFormat = 'audio/mpeg';
          break;
        case 'ogg':
        case 'ogg_vorbis':
        case 'x-cbr-opus-with-preamble':
        default:
          state.polly.outputFormat = 'ogg_vorbis';
          state.lex.acceptFormat = 'audio/ogg';
          break;
      }
    },
    updateIdentityId: function updateIdentityId(state) {
      state.awsCreds.identityId = __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default.a.config.credentials.identityId;
    },
    setAwsCredsProvider: function setAwsCredsProvider(state, provider) {
      state.awsCreds.provider = provider;
    },
    setIsRecorderSupported: function setIsRecorderSupported(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setIsRecorderSupported status not boolean', bool);
        return;
      }
      state.recState.isRecorderSupported = bool;
    },
    setIsRunningEmbedded: function setIsRunningEmbedded(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setIsRunningEmbedded status not boolean', bool);
        return;
      }
      state.isRunningEmbedded = bool;
    },
    setUrlQueryParams: function setUrlQueryParams(state, query) {
      if ((typeof query === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(query)) !== 'object') {
        console.error('query is not an object', query);
        return;
      }
      state.urlQueryParams = query;
    },
    mergeConfig: function mergeConfig(state, configObj) {
      if ((typeof configObj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(configObj)) !== 'object') {
        console.error('config is not an object', configObj);
        return;
      }

      if (configObj.ui && configObj.ui.parentOrigin) {
        delete configObj.ui.parentOrigin;
      }
      state.config = Object(__WEBPACK_IMPORTED_MODULE_10__config__["b" /* mergeConfig */])(state.config, configObj);
    },
    setLexSessionAttributes: function setLexSessionAttributes(state, sessionAttributes) {
      if ((typeof sessionAttributes === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(sessionAttributes)) !== 'object') {
        console.error('sessionAttributes is not an object', sessionAttributes);
        return;
      }
      state.lex.sessionAttributes = sessionAttributes;
    },
    setPollyVoiceId: function setPollyVoiceId(state, voiceId) {
      if (typeof voiceId !== 'string') {
        console.error('polly voiceId is not a string', voiceId);
        return;
      }
      state.polly.voiceId = voiceId;
    },
    setRecorderOptions: function setRecorderOptions(state, recorderOptions) {
      if ((typeof recorderOptions === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(recorderOptions)) !== 'object') {
        console.error('recorderOptions is not an object', recorderOptions);
      }
      state.recorder.initOptions(recorderOptions);
    },
    setIsLexInterrupting: function setIsLexInterrupting(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setIsLexInterrupting status not boolean', bool);
        return;
      }
      state.lex.isInterrupting = bool;
    },
    setCanInterruptBotPlayback: function setCanInterruptBotPlayback(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setCanInterruptBotPlayback status not boolean', bool);
        return;
      }
      state.botAudio.canInterrupt = bool;
    },
    setIsBotPlaybackInterrupting: function setIsBotPlaybackInterrupting(state, bool) {
      if (typeof bool !== 'boolean') {
        console.error('setIsBotPlaybackInterrupting status not boolean', bool);
        return;
      }
      state.botAudio.isInterrupting = bool;
    },
    setBotPlaybackInterruptIntervalId: function setBotPlaybackInterruptIntervalId(state, id) {
      if (typeof id !== 'number') {
        console.error('setIsBotPlaybackInterruptIntervalId id is not a number', id);
        return;
      }
      state.botAudio.interruptIntervalId = id;
    },
    toggleIsUiMinimized: function toggleIsUiMinimized(state) {
      state.isUiMinimized = !state.isUiMinimized;
    }
  },

  actions: {
    initCredentials: function initCredentials(context) {
      switch (context.state.awsCreds.provider) {
        case 'cognito':
          __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default.a.config.credentials = new __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default.a.CognitoIdentityCredentials({
            IdentityPoolId: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].cognito.poolId
          });
          return context.dispatch('getCredentials');
        case 'parentWindow':
          return context.dispatch('sendMessageToParentWindow', { event: 'getCredentials' }).then(function (credsResponse) {
            if (credsResponse.event === 'resolve' && credsResponse.type === 'getCredentials') {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(credsResponse.data);
            }
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('invalid credential event from parent');
          }).then(function (creds) {
            __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default.a.config.credentials = new __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default.a.CognitoIdentityCredentials(creds.params);

            if (!('getPromise' in __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default.a.config.credentials)) {
              var error = 'getPromise not found in state credentials';
              console.error(error);
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
            }

            return context.dispatch('getCredentials');
          });
        default:
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('unknown credential provider');
      }
    },
    getConfigFromParent: function getConfigFromParent(context) {
      if (!context.state.isRunningEmbedded) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});
      }

      return context.dispatch('sendMessageToParentWindow', { event: 'initIframeConfig' }).then(function (configResponse) {
        if (configResponse.event === 'resolve' && configResponse.type === 'initIframeConfig') {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(configResponse.data);
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('invalid config event from parent');
      });
    },
    initConfig: function initConfig(context, configObj) {
      context.commit('mergeConfig', configObj);
    },
    initMessageList: function initMessageList(context) {
      context.commit('pushMessage', {
        type: 'bot',
        text: context.state.config.lex.initialText
      });
    },
    initLexClient: function initLexClient(context) {
      lexClient.botName = context.state.config.lex.botName;
      lexClient.botAlias = context.state.config.lex.botAlias;
      lexClient.region = context.state.config.region;
      context.commit('setLexSessionAttributes', context.state.config.lex.sessionAttributes);
      return context.dispatch('getCredentials').then(function (creds) {
        lexClient.identityId = context.state.awsCreds.identityId;
        lexClient.lexRuntime.config.credentials = creds;
      });
    },
    initPollyClient: function initPollyClient(context) {
      if (!context.state.recState.isRecorderEnabled) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }
      context.commit('setPollyVoiceId', context.state.config.polly.voiceId);
      return context.dispatch('getCredentials').then(function (creds) {
        pollyClient.config.credentials = creds;
      });
    },
    initRecorder: function initRecorder(context) {
      if (!context.state.recState.isRecorderEnabled) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }
      return context.state.recorder.init().then(function () {
        return context.commit('setRecorderOptions', context.state.config.recorder);
      }).then(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_9__recorder_handlers__["a" /* default */])(context);
      }).then(function () {
        return context.commit('setIsRecorderSupported', true);
      }).then(function () {
        return context.commit('setIsMicMuted', context.state.recorder.isMicMuted);
      }).catch(function (error) {
        if (['PermissionDeniedError', 'NotAllowedError'].indexOf(error.name) >= 0) {
          console.warn('get user media permission denied');
          context.dispatch('pushErrorMessage', 'It seems like the microphone access has been denied. ' + 'If you want to use voice, please allow mic usage in your browser.');
        } else {
          console.error('error while initRecorder', error);
        }
      });
    },
    initBotAudio: function initBotAudio(context) {
      if (!context.state.recState.isRecorderEnabled) {
        return;
      }
      var silentSound = void 0;
      var audio = context.state.botAudio.audio;

      if (audio.canPlayType('audio/ogg') !== '') {
        context.commit('setAudioContentType', 'ogg');
        silentSound = __WEBPACK_IMPORTED_MODULE_11__assets_silent_ogg___default.a;
      } else if (audio.canPlayType('audio/mp3') !== '') {
        context.commit('setAudioContentType', 'mp3');
        silentSound = __WEBPACK_IMPORTED_MODULE_12__assets_silent_mp3___default.a;
      } else {
        console.error('init audio could not find supportted audio type');
        console.warn('init audio can play mp3 [%s]', audio.canPlayType('audio/mp3'));
        console.warn('init audio can play ogg [%s]', audio.canPlayType('audio/ogg'));
      }

      console.info('recorder content types: %s', context.state.recorder.mimeType);

      audio.preload = 'auto';
      audio.autoplay = true;

      audio.src = silentSound;
    },
    reInitBot: function reInitBot(context) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        return context.state.config.ui.pushInitialTextOnRestart ? context.dispatch('pushMessage', {
          text: context.state.config.lex.initialText,
          type: 'bot'
        }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }).then(function () {
        return context.state.config.lex.reInitSessionAttributesOnRestart ? context.commit('setLexSessionAttributes', context.state.config.lex.sessionAttributes) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      });
    },
    getAudioUrl: function getAudioUrl(context, blob) {
      var url = void 0;

      try {
        url = URL.createObjectURL(blob);
      } catch (error) {
        console.error('getAudioUrl createObjectURL error', error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('There was an error processing the audio response (' + error + ')');
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(url);
    },
    playAudio: function playAudio(context, url) {
      var audio = context.state.botAudio.audio;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        audio.onloadedmetadata = function () {
          context.commit('setIsBotSpeaking', true);
          context.dispatch('playAudioHandler').then(function () {
            return resolve();
          });
        };

        audio.src = url;
      });
    },
    playAudioHandler: function playAudioHandler(context) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var enablePlaybackInterrupt = context.state.config.lex.enablePlaybackInterrupt;
        var audio = context.state.botAudio.audio;


        var clearPlayback = function clearPlayback() {
          context.commit('setIsBotSpeaking', false);
          var intervalId = context.state.botAudio.interruptIntervalId;
          if (intervalId && enablePlaybackInterrupt) {
            clearInterval(intervalId);
            context.commit('setBotPlaybackInterruptIntervalId', 0);
            context.commit('setIsLexInterrupting', false);
            context.commit('setCanInterruptBotPlayback', false);
            context.commit('setIsBotPlaybackInterrupting', false);
          }
        };

        audio.onerror = function (error) {
          clearPlayback();
          reject('There was an error playing the response (' + error + ')');
        };
        audio.onended = function () {
          clearPlayback();
          resolve();
        };
        audio.onpause = audio.onended;

        if (enablePlaybackInterrupt) {
          context.dispatch('playAudioInterruptHandler');
        }
      });
    },
    playAudioInterruptHandler: function playAudioInterruptHandler(context) {
      var _context$state$botAud = context.state.botAudio,
          audio = _context$state$botAud.audio,
          isSpeaking = _context$state$botAud.isSpeaking;
      var _context$state$config = context.state.config.lex,
          enablePlaybackInterrupt = _context$state$config.enablePlaybackInterrupt,
          playbackInterruptMinDuration = _context$state$config.playbackInterruptMinDuration,
          playbackInterruptVolumeThreshold = _context$state$config.playbackInterruptVolumeThreshold,
          playbackInterruptLevelThreshold = _context$state$config.playbackInterruptLevelThreshold,
          playbackInterruptNoiseThreshold = _context$state$config.playbackInterruptNoiseThreshold;

      var intervalTimeInMs = 200;

      if (!enablePlaybackInterrupt && !isSpeaking && context.state.lex.isInterrupting && audio.duration < playbackInterruptMinDuration) {
        return;
      }

      var intervalId = setInterval(function () {
        var duration = audio.duration;
        var end = audio.played.end(0);
        var canInterrupt = context.state.botAudio.canInterrupt;


        if (!canInterrupt && end > playbackInterruptMinDuration && duration - end > 0.5 && recorder.volume.max < playbackInterruptNoiseThreshold) {
          context.commit('setCanInterruptBotPlayback', true);
        } else if (canInterrupt && duration - end < 0.5) {
          context.commit('setCanInterruptBotPlayback', false);
        }

        if (canInterrupt && recorder.volume.max > playbackInterruptVolumeThreshold && recorder.volume.slow > playbackInterruptLevelThreshold) {
          clearInterval(intervalId);
          context.commit('setIsBotPlaybackInterrupting', true);
          setTimeout(function () {
            audio.pause();
          }, 500);
        }
      }, intervalTimeInMs);

      context.commit('setBotPlaybackInterruptIntervalId', intervalId);
    },
    startConversation: function startConversation(context) {
      context.commit('setIsConversationGoing', true);
      return context.dispatch('startRecording');
    },
    stopConversation: function stopConversation(context) {
      context.commit('setIsConversationGoing', false);
    },
    startRecording: function startRecording(context) {
      if (context.state.recState.isMicMuted === true) {
        console.warn('recording while muted');
        context.dispatch('stopConversation');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('The microphone seems to be muted.');
      }

      context.commit('startRecording');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    pollyGetBlob: function pollyGetBlob(context, text) {
      var synthReq = pollyClient.synthesizeSpeech({
        Text: text,
        VoiceId: context.state.polly.voiceId,
        OutputFormat: context.state.polly.outputFormat
      });
      return context.dispatch('getCredentials').then(function () {
        return synthReq.promise();
      }).then(function (data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(new Blob([data.AudioStream], { type: data.ContentType }));
      });
    },
    pollySynthesizeSpeech: function pollySynthesizeSpeech(context, text) {
      return context.dispatch('pollyGetBlob', text).then(function (blob) {
        return context.dispatch('getAudioUrl', blob);
      }).then(function (audioUrl) {
        return context.dispatch('playAudio', audioUrl);
      });
    },
    interruptSpeechConversation: function interruptSpeechConversation(context) {
      if (!context.state.recState.isConversationGoing) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        context.dispatch('stopConversation').then(function () {
          context.state.recorder.stop();
          return context.dispatch('stopRecording');
        }).then(function () {
          if (context.state.botAudio.isSpeaking) {
            context.state.botAudio.audio.pause();
          }
        }).then(function () {
          var count = 0;
          var countMax = 20;
          var intervalTimeInMs = 250;
          context.commit('setIsLexInterrupting', true);
          var intervalId = setInterval(function () {
            if (!context.state.lex.isProcessing) {
              clearInterval(intervalId);
              context.commit('setIsLexInterrupting', false);
              resolve();
            }
            if (count > countMax) {
              clearInterval(intervalId);
              context.commit('setIsLexInterrupting', false);
              reject('interrupt interval exceeded');
            }
            count += 1;
          }, intervalTimeInMs);
        });
      });
    },
    postTextMessage: function postTextMessage(context, message) {
      context.dispatch('interruptSpeechConversation').then(function () {
        return context.dispatch('pushMessage', message);
      }).then(function () {
        return context.dispatch('lexPostText', message.text);
      }).then(function (response) {
        return context.dispatch('pushMessage', {
          text: response.message,
          type: 'bot',
          dialogState: context.state.lex.dialogState,
          responseCard: context.state.lex.responseCard
        });
      }).then(function () {
        if (context.state.lex.dialogState === 'Fulfilled') {
          context.dispatch('reInitBot');
        }
      }).catch(function (error) {
        console.error('error in postTextMessage', error);
        context.dispatch('pushErrorMessage', 'I was unable to process your message. ' + error);
      });
    },
    lexPostText: function lexPostText(context, text) {
      context.commit('setIsLexProcessing', true);
      return context.dispatch('getCredentials').then(function () {
        return lexClient.postText(text, context.state.lex.sessionAttributes);
      }).then(function (data) {
        context.commit('setIsLexProcessing', false);
        return context.dispatch('updateLexState', data).then(function () {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
        });
      });
    },
    lexPostContent: function lexPostContent(context, audioBlob) {
      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      context.commit('setIsLexProcessing', true);
      console.info('audio blob size:', audioBlob.size);
      var timeStart = void 0;

      return context.dispatch('getCredentials').then(function () {
        timeStart = performance.now();
        return lexClient.postContent(audioBlob, context.state.lex.sessionAttributes, context.state.lex.acceptFormat, offset);
      }).then(function (lexResponse) {
        var timeEnd = performance.now();
        console.info('lex postContent processing time:', ((timeEnd - timeStart) / 1000).toFixed(2));
        context.commit('setIsLexProcessing', false);
        return context.dispatch('updateLexState', lexResponse).then(function () {
          return context.dispatch('processLexContentResponse', lexResponse);
        }).then(function (blob) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(blob);
        });
      });
    },
    processLexContentResponse: function processLexContentResponse(context, lexData) {
      var audioStream = lexData.audioStream,
          contentType = lexData.contentType,
          dialogState = lexData.dialogState;


      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (!audioStream || !audioStream.length) {
          var text = dialogState === 'ReadyForFulfillment' ? 'All done' : 'There was an error';
          return context.dispatch('pollyGetBlob', text);
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(new Blob([audioStream], { type: contentType }));
      });
    },
    updateLexState: function updateLexState(context, lexState) {
      var lexStateDefault = {
        dialogState: '',
        inputTranscript: '',
        intentName: '',
        message: '',
        responseCard: null,
        sessionAttributes: {},
        slotToElicit: '',
        slots: {}
      };

      if ('sessionAttributes' in lexState && 'appContext' in lexState.sessionAttributes) {
        try {
          var appContext = JSON.parse(lexState.sessionAttributes.appContext);
          if ('responseCard' in appContext) {
            lexStateDefault.responseCard = appContext.responseCard;
          }
        } catch (e) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('error parsing appContext in sessionAttributes');
        }
      }
      context.commit('updateLexState', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, lexStateDefault, lexState));
      if (context.state.isRunningEmbedded) {
        context.dispatch('sendMessageToParentWindow', { event: 'updateLexState', state: context.state.lex });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    stopRecording: function stopRecording(context) {
      context.commit('stopRecording');
    },
    pushMessage: function pushMessage(context, message) {
      context.commit('pushMessage', message);
    },
    pushErrorMessage: function pushErrorMessage(context, text) {
      var dialogState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Failed';

      context.commit('pushMessage', {
        type: 'bot',
        text: text,
        dialogState: dialogState
      });
    },
    getCredentials: function getCredentials(context) {
      return __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default.a.config.credentials.getPromise().then(function () {
        context.commit('updateIdentityId');
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(__WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default.a.config.credentials);
      });
    },
    toggleIsUiMinimized: function toggleIsUiMinimized(context) {
      context.commit('toggleIsUiMinimized');
      return context.dispatch('sendMessageToParentWindow', { event: 'toggleMinimizeUi' });
    },
    sendMessageToParentWindow: function sendMessageToParentWindow(context, message) {
      if (!context.state.isRunningEmbedded) {
        var error = 'sendMessage called when not running embedded';
        console.warn(error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = function (evt) {
          messageChannel.port1.close();
          messageChannel.port2.close();
          if (evt.data.event === 'resolve') {
            resolve(evt.data);
          } else {
            reject('error in sendMessageToParentWindow ' + evt.data.error);
          }
        };
        parent.postMessage(message, __WEBPACK_IMPORTED_MODULE_10__config__["a" /* config */].ui.parentOrigin, [messageChannel.port2]);
      });
    }
  }
}));

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

module.exports = {
	"rules": {
		"*/*": {
			"endpoint": "{service}.{region}.amazonaws.com"
		},
		"cn-*/*": {
			"endpoint": "{service}.{region}.amazonaws.com.cn"
		},
		"*/budgets": "globalSSL",
		"*/cloudfront": "globalSSL",
		"*/iam": "globalSSL",
		"*/sts": "globalSSL",
		"*/importexport": {
			"endpoint": "{service}.amazonaws.com",
			"signatureVersion": "v2",
			"globalEndpoint": true
		},
		"*/route53": {
			"endpoint": "https://{service}.amazonaws.com",
			"signatureVersion": "v3https",
			"globalEndpoint": true
		},
		"*/waf": "globalSSL",
		"us-gov-*/iam": "globalGovCloud",
		"us-gov-*/sts": {
			"endpoint": "{service}.{region}.amazonaws.com"
		},
		"us-gov-west-1/s3": "s3dash",
		"us-west-1/s3": "s3dash",
		"us-west-2/s3": "s3dash",
		"eu-west-1/s3": "s3dash",
		"ap-southeast-1/s3": "s3dash",
		"ap-southeast-2/s3": "s3dash",
		"ap-northeast-1/s3": "s3dash",
		"sa-east-1/s3": "s3dash",
		"us-east-1/s3": {
			"endpoint": "{service}.amazonaws.com",
			"signatureVersion": "s3"
		},
		"us-east-1/sdb": {
			"endpoint": "{service}.amazonaws.com",
			"signatureVersion": "v2"
		},
		"*/sdb": {
			"endpoint": "{service}.{region}.amazonaws.com",
			"signatureVersion": "v2"
		}
	},
	"patterns": {
		"globalSSL": {
			"endpoint": "https://{service}.amazonaws.com",
			"globalEndpoint": true
		},
		"globalGovCloud": {
			"endpoint": "{service}.us-gov.amazonaws.com"
		},
		"s3dash": {
			"endpoint": "{service}-{region}.amazonaws.com",
			"signatureVersion": "s3"
		}
	}
};

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

module.exports = {
	"acm": {
		"name": "ACM",
		"cors": true
	},
	"apigateway": {
		"name": "APIGateway",
		"cors": true
	},
	"applicationautoscaling": {
		"prefix": "application-autoscaling",
		"name": "ApplicationAutoScaling",
		"cors": true
	},
	"appstream": {
		"name": "AppStream"
	},
	"autoscaling": {
		"name": "AutoScaling",
		"cors": true
	},
	"batch": {
		"name": "Batch"
	},
	"budgets": {
		"name": "Budgets"
	},
	"clouddirectory": {
		"name": "CloudDirectory"
	},
	"cloudformation": {
		"name": "CloudFormation",
		"cors": true
	},
	"cloudfront": {
		"name": "CloudFront",
		"versions": [
			"2013-05-12*",
			"2013-11-11*",
			"2014-05-31*",
			"2014-10-21*",
			"2014-11-06*",
			"2015-04-17*",
			"2015-07-27*",
			"2015-09-17*",
			"2016-01-13*",
			"2016-01-28*",
			"2016-08-01*",
			"2016-08-20*",
			"2016-09-07*",
			"2016-09-29*",
			"2016-11-25*"
		],
		"cors": true
	},
	"cloudhsm": {
		"name": "CloudHSM",
		"cors": true
	},
	"cloudsearch": {
		"name": "CloudSearch"
	},
	"cloudsearchdomain": {
		"name": "CloudSearchDomain"
	},
	"cloudtrail": {
		"name": "CloudTrail",
		"cors": true
	},
	"cloudwatch": {
		"prefix": "monitoring",
		"name": "CloudWatch",
		"cors": true
	},
	"cloudwatchevents": {
		"prefix": "events",
		"name": "CloudWatchEvents",
		"versions": [
			"2014-02-03*"
		],
		"cors": true
	},
	"cloudwatchlogs": {
		"prefix": "logs",
		"name": "CloudWatchLogs",
		"cors": true
	},
	"codebuild": {
		"name": "CodeBuild"
	},
	"codecommit": {
		"name": "CodeCommit",
		"cors": true
	},
	"codedeploy": {
		"name": "CodeDeploy",
		"cors": true
	},
	"codepipeline": {
		"name": "CodePipeline",
		"cors": true
	},
	"cognitoidentity": {
		"prefix": "cognito-identity",
		"name": "CognitoIdentity",
		"cors": true
	},
	"cognitoidentityserviceprovider": {
		"prefix": "cognito-idp",
		"name": "CognitoIdentityServiceProvider",
		"cors": true
	},
	"cognitosync": {
		"prefix": "cognito-sync",
		"name": "CognitoSync",
		"cors": true
	},
	"configservice": {
		"prefix": "config",
		"name": "ConfigService",
		"cors": true
	},
	"cur": {
		"name": "CUR",
		"cors": true
	},
	"datapipeline": {
		"name": "DataPipeline"
	},
	"devicefarm": {
		"name": "DeviceFarm",
		"cors": true
	},
	"directconnect": {
		"name": "DirectConnect",
		"cors": true
	},
	"directoryservice": {
		"prefix": "ds",
		"name": "DirectoryService"
	},
	"discovery": {
		"name": "Discovery"
	},
	"dms": {
		"name": "DMS"
	},
	"dynamodb": {
		"name": "DynamoDB",
		"cors": true
	},
	"dynamodbstreams": {
		"prefix": "streams.dynamodb",
		"name": "DynamoDBStreams",
		"cors": true
	},
	"ec2": {
		"name": "EC2",
		"versions": [
			"2013-06-15*",
			"2013-10-15*",
			"2014-02-01*",
			"2014-05-01*",
			"2014-06-15*",
			"2014-09-01*",
			"2014-10-01*",
			"2015-03-01*",
			"2015-04-15*",
			"2015-10-01*",
			"2016-04-01*",
			"2016-09-15*"
		],
		"cors": true
	},
	"ecr": {
		"name": "ECR",
		"cors": true
	},
	"ecs": {
		"name": "ECS",
		"cors": true
	},
	"efs": {
		"prefix": "elasticfilesystem",
		"name": "EFS",
		"cors": true
	},
	"elasticache": {
		"name": "ElastiCache",
		"versions": [
			"2012-11-15*",
			"2014-03-24*",
			"2014-07-15*",
			"2014-09-30*"
		],
		"cors": true
	},
	"elasticbeanstalk": {
		"name": "ElasticBeanstalk",
		"cors": true
	},
	"elb": {
		"prefix": "elasticloadbalancing",
		"name": "ELB",
		"cors": true
	},
	"elbv2": {
		"prefix": "elasticloadbalancingv2",
		"name": "ELBv2",
		"cors": true
	},
	"emr": {
		"prefix": "elasticmapreduce",
		"name": "EMR",
		"cors": true
	},
	"es": {
		"name": "ES"
	},
	"elastictranscoder": {
		"name": "ElasticTranscoder",
		"cors": true
	},
	"firehose": {
		"name": "Firehose",
		"cors": true
	},
	"gamelift": {
		"name": "GameLift",
		"cors": true
	},
	"glacier": {
		"name": "Glacier"
	},
	"health": {
		"name": "Health"
	},
	"iam": {
		"name": "IAM"
	},
	"importexport": {
		"name": "ImportExport"
	},
	"inspector": {
		"name": "Inspector",
		"versions": [
			"2015-08-18*"
		],
		"cors": true
	},
	"iot": {
		"name": "Iot",
		"cors": true
	},
	"iotdata": {
		"prefix": "iot-data",
		"name": "IotData",
		"cors": true
	},
	"kinesis": {
		"name": "Kinesis",
		"cors": true
	},
	"kinesisanalytics": {
		"name": "KinesisAnalytics"
	},
	"kms": {
		"name": "KMS",
		"cors": true
	},
	"lambda": {
		"name": "Lambda",
		"cors": true
	},
	"lexruntime": {
		"prefix": "runtime.lex",
		"name": "LexRuntime",
		"cors": true
	},
	"lightsail": {
		"name": "Lightsail"
	},
	"machinelearning": {
		"name": "MachineLearning",
		"cors": true
	},
	"marketplacecommerceanalytics": {
		"name": "MarketplaceCommerceAnalytics",
		"cors": true
	},
	"marketplacemetering": {
		"prefix": "meteringmarketplace",
		"name": "MarketplaceMetering"
	},
	"mturk": {
		"prefix": "mturk-requester",
		"name": "MTurk",
		"cors": true
	},
	"mobileanalytics": {
		"name": "MobileAnalytics",
		"cors": true
	},
	"opsworks": {
		"name": "OpsWorks",
		"cors": true
	},
	"opsworkscm": {
		"name": "OpsWorksCM"
	},
	"organizations": {
		"name": "Organizations"
	},
	"pinpoint": {
		"name": "Pinpoint"
	},
	"polly": {
		"name": "Polly",
		"cors": true
	},
	"rds": {
		"name": "RDS",
		"versions": [
			"2014-09-01*"
		],
		"cors": true
	},
	"redshift": {
		"name": "Redshift",
		"cors": true
	},
	"rekognition": {
		"name": "Rekognition",
		"cors": true
	},
	"resourcegroupstaggingapi": {
		"name": "ResourceGroupsTaggingAPI"
	},
	"route53": {
		"name": "Route53",
		"cors": true
	},
	"route53domains": {
		"name": "Route53Domains",
		"cors": true
	},
	"s3": {
		"name": "S3",
		"dualstackAvailable": true,
		"cors": true
	},
	"servicecatalog": {
		"name": "ServiceCatalog",
		"cors": true
	},
	"ses": {
		"prefix": "email",
		"name": "SES",
		"cors": true
	},
	"shield": {
		"name": "Shield"
	},
	"simpledb": {
		"prefix": "sdb",
		"name": "SimpleDB"
	},
	"sms": {
		"name": "SMS"
	},
	"snowball": {
		"name": "Snowball"
	},
	"sns": {
		"name": "SNS",
		"cors": true
	},
	"sqs": {
		"name": "SQS",
		"cors": true
	},
	"ssm": {
		"name": "SSM",
		"cors": true
	},
	"storagegateway": {
		"name": "StorageGateway",
		"cors": true
	},
	"stepfunctions": {
		"prefix": "states",
		"name": "StepFunctions"
	},
	"sts": {
		"name": "STS",
		"cors": true
	},
	"support": {
		"name": "Support"
	},
	"swf": {
		"name": "SWF"
	},
	"xray": {
		"name": "XRay"
	},
	"waf": {
		"name": "WAF",
		"cors": true
	},
	"wafregional": {
		"prefix": "waf-regional",
		"name": "WAFRegional"
	},
	"workdocs": {
		"name": "WorkDocs",
		"cors": true
	},
	"workspaces": {
		"name": "WorkSpaces"
	},
	"codestar": {
		"name": "CodeStar"
	},
	"lexmodelbuildingservice": {
		"prefix": "lex-models",
		"name": "LexModelBuildingService"
	},
	"marketplaceentitlementservice": {
		"prefix": "entitlement.marketplace",
		"name": "MarketplaceEntitlementService"
	},
	"athena": {
		"name": "Athena"
	},
	"greengrass": {
		"name": "Greengrass"
	},
	"dax": {
		"name": "DAX"
	}
};

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2011-06-15",
		"endpointPrefix": "sts",
		"globalEndpoint": "sts.amazonaws.com",
		"protocol": "query",
		"serviceAbbreviation": "AWS STS",
		"serviceFullName": "AWS Security Token Service",
		"signatureVersion": "v4",
		"uid": "sts-2011-06-15",
		"xmlNamespace": "https://sts.amazonaws.com/doc/2011-06-15/"
	},
	"operations": {
		"AssumeRole": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"RoleSessionName"
				],
				"members": {
					"RoleArn": {},
					"RoleSessionName": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					},
					"ExternalId": {},
					"SerialNumber": {},
					"TokenCode": {}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					}
				}
			}
		},
		"AssumeRoleWithSAML": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"PrincipalArn",
					"SAMLAssertion"
				],
				"members": {
					"RoleArn": {},
					"PrincipalArn": {},
					"SAMLAssertion": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleWithSAMLResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					},
					"Subject": {},
					"SubjectType": {},
					"Issuer": {},
					"Audience": {},
					"NameQualifier": {}
				}
			}
		},
		"AssumeRoleWithWebIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"RoleSessionName",
					"WebIdentityToken"
				],
				"members": {
					"RoleArn": {},
					"RoleSessionName": {},
					"WebIdentityToken": {},
					"ProviderId": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleWithWebIdentityResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"SubjectFromWebIdentityToken": {},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					},
					"Provider": {},
					"Audience": {}
				}
			}
		},
		"DecodeAuthorizationMessage": {
			"input": {
				"type": "structure",
				"required": [
					"EncodedMessage"
				],
				"members": {
					"EncodedMessage": {}
				}
			},
			"output": {
				"resultWrapper": "DecodeAuthorizationMessageResult",
				"type": "structure",
				"members": {
					"DecodedMessage": {}
				}
			}
		},
		"GetCallerIdentity": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"resultWrapper": "GetCallerIdentityResult",
				"type": "structure",
				"members": {
					"UserId": {},
					"Account": {},
					"Arn": {}
				}
			}
		},
		"GetFederationToken": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "GetFederationTokenResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"FederatedUser": {
						"type": "structure",
						"required": [
							"FederatedUserId",
							"Arn"
						],
						"members": {
							"FederatedUserId": {},
							"Arn": {}
						}
					},
					"PackedPolicySize": {
						"type": "integer"
					}
				}
			}
		},
		"GetSessionToken": {
			"input": {
				"type": "structure",
				"members": {
					"DurationSeconds": {
						"type": "integer"
					},
					"SerialNumber": {},
					"TokenCode": {}
				}
			},
			"output": {
				"resultWrapper": "GetSessionTokenResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					}
				}
			}
		}
	},
	"shapes": {
		"Sa": {
			"type": "structure",
			"required": [
				"AccessKeyId",
				"SecretAccessKey",
				"SessionToken",
				"Expiration"
			],
			"members": {
				"AccessKeyId": {},
				"SecretAccessKey": {},
				"SessionToken": {},
				"Expiration": {
					"type": "timestamp"
				}
			}
		},
		"Sf": {
			"type": "structure",
			"required": [
				"AssumedRoleId",
				"Arn"
			],
			"members": {
				"AssumedRoleId": {},
				"Arn": {}
			}
		}
	}
};

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-06-30",
		"endpointPrefix": "cognito-identity",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Cognito Identity",
		"signatureVersion": "v4",
		"targetPrefix": "AWSCognitoIdentityService",
		"uid": "cognito-identity-2014-06-30"
	},
	"operations": {
		"CreateIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolName",
					"AllowUnauthenticatedIdentities"
				],
				"members": {
					"IdentityPoolName": {},
					"AllowUnauthenticatedIdentities": {
						"type": "boolean"
					},
					"SupportedLoginProviders": {
						"shape": "S4"
					},
					"DeveloperProviderName": {},
					"OpenIdConnectProviderARNs": {
						"shape": "S8"
					},
					"CognitoIdentityProviders": {
						"shape": "Sa"
					},
					"SamlProviderARNs": {
						"shape": "Sf"
					}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"DeleteIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityIdsToDelete"
				],
				"members": {
					"IdentityIdsToDelete": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UnprocessedIdentityIds": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IdentityId": {},
								"ErrorCode": {}
							}
						}
					}
				}
			}
		},
		"DeleteIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			}
		},
		"DescribeIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {}
				}
			},
			"output": {
				"shape": "Sr"
			}
		},
		"DescribeIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"GetCredentialsForIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					},
					"CustomRoleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Credentials": {
						"type": "structure",
						"members": {
							"AccessKeyId": {},
							"SecretKey": {},
							"SessionToken": {},
							"Expiration": {
								"type": "timestamp"
							}
						}
					}
				}
			}
		},
		"GetId": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"AccountId": {},
					"IdentityPoolId": {},
					"Logins": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {}
				}
			}
		},
		"GetIdentityPoolRoles": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"Roles": {
						"shape": "S18"
					},
					"RoleMappings": {
						"shape": "S1a"
					}
				}
			}
		},
		"GetOpenIdToken": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Token": {}
				}
			}
		},
		"GetOpenIdTokenForDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"Logins"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					},
					"TokenDuration": {
						"type": "long"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Token": {}
				}
			}
		},
		"ListIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"MaxResults"
				],
				"members": {
					"IdentityPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"HideDisabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"Identities": {
						"type": "list",
						"member": {
							"shape": "Sr"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentityPools": {
			"input": {
				"type": "structure",
				"required": [
					"MaxResults"
				],
				"members": {
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPools": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IdentityPoolId": {},
								"IdentityPoolName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"LookupDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityId": {},
					"DeveloperUserIdentifier": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"DeveloperUserIdentifierList": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			}
		},
		"MergeDeveloperIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"SourceUserIdentifier",
					"DestinationUserIdentifier",
					"DeveloperProviderName",
					"IdentityPoolId"
				],
				"members": {
					"SourceUserIdentifier": {},
					"DestinationUserIdentifier": {},
					"DeveloperProviderName": {},
					"IdentityPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {}
				}
			}
		},
		"SetIdentityPoolRoles": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"Roles"
				],
				"members": {
					"IdentityPoolId": {},
					"Roles": {
						"shape": "S18"
					},
					"RoleMappings": {
						"shape": "S1a"
					}
				}
			}
		},
		"UnlinkDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId",
					"IdentityPoolId",
					"DeveloperProviderName",
					"DeveloperUserIdentifier"
				],
				"members": {
					"IdentityId": {},
					"IdentityPoolId": {},
					"DeveloperProviderName": {},
					"DeveloperUserIdentifier": {}
				}
			}
		},
		"UnlinkIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId",
					"Logins",
					"LoginsToRemove"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					},
					"LoginsToRemove": {
						"shape": "Ss"
					}
				}
			}
		},
		"UpdateIdentityPool": {
			"input": {
				"shape": "Sg"
			},
			"output": {
				"shape": "Sg"
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S8": {
			"type": "list",
			"member": {}
		},
		"Sa": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ProviderName": {},
					"ClientId": {},
					"ServerSideTokenCheck": {
						"type": "boolean"
					}
				}
			}
		},
		"Sf": {
			"type": "list",
			"member": {}
		},
		"Sg": {
			"type": "structure",
			"required": [
				"IdentityPoolId",
				"IdentityPoolName",
				"AllowUnauthenticatedIdentities"
			],
			"members": {
				"IdentityPoolId": {},
				"IdentityPoolName": {},
				"AllowUnauthenticatedIdentities": {
					"type": "boolean"
				},
				"SupportedLoginProviders": {
					"shape": "S4"
				},
				"DeveloperProviderName": {},
				"OpenIdConnectProviderARNs": {
					"shape": "S8"
				},
				"CognitoIdentityProviders": {
					"shape": "Sa"
				},
				"SamlProviderARNs": {
					"shape": "Sf"
				}
			}
		},
		"Sr": {
			"type": "structure",
			"members": {
				"IdentityId": {},
				"Logins": {
					"shape": "Ss"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				}
			}
		},
		"Ss": {
			"type": "list",
			"member": {}
		},
		"Sw": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S18": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1a": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"Type": {},
					"AmbiguousRoleResolution": {},
					"RulesConfiguration": {
						"type": "structure",
						"required": [
							"Rules"
						],
						"members": {
							"Rules": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"Claim",
										"MatchType",
										"Value",
										"RoleARN"
									],
									"members": {
										"Claim": {},
										"MatchType": {},
										"Value": {},
										"RoleARN": {}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-06-10",
		"endpointPrefix": "polly",
		"protocol": "rest-json",
		"serviceFullName": "Amazon Polly",
		"signatureVersion": "v4",
		"uid": "polly-2016-06-10"
	},
	"operations": {
		"DeleteLexicon": {
			"http": {
				"method": "DELETE",
				"requestUri": "/v1/lexicons/{LexiconName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {
						"shape": "S2",
						"location": "uri",
						"locationName": "LexiconName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeVoices": {
			"http": {
				"method": "GET",
				"requestUri": "/v1/voices",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"LanguageCode": {
						"location": "querystring",
						"locationName": "LanguageCode"
					},
					"NextToken": {
						"location": "querystring",
						"locationName": "NextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Voices": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Gender": {},
								"Id": {},
								"LanguageCode": {},
								"LanguageName": {},
								"Name": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetLexicon": {
			"http": {
				"method": "GET",
				"requestUri": "/v1/lexicons/{LexiconName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {
						"shape": "S2",
						"location": "uri",
						"locationName": "LexiconName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Lexicon": {
						"type": "structure",
						"members": {
							"Content": {},
							"Name": {
								"shape": "S2"
							}
						}
					},
					"LexiconAttributes": {
						"shape": "Si"
					}
				}
			}
		},
		"ListLexicons": {
			"http": {
				"method": "GET",
				"requestUri": "/v1/lexicons",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {
						"location": "querystring",
						"locationName": "NextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Lexicons": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {
									"shape": "S2"
								},
								"Attributes": {
									"shape": "Si"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"PutLexicon": {
			"http": {
				"method": "PUT",
				"requestUri": "/v1/lexicons/{LexiconName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Content"
				],
				"members": {
					"Name": {
						"shape": "S2",
						"location": "uri",
						"locationName": "LexiconName"
					},
					"Content": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"SynthesizeSpeech": {
			"http": {
				"requestUri": "/v1/speech",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"OutputFormat",
					"Text",
					"VoiceId"
				],
				"members": {
					"LexiconNames": {
						"type": "list",
						"member": {
							"shape": "S2"
						}
					},
					"OutputFormat": {},
					"SampleRate": {},
					"SpeechMarkTypes": {
						"type": "list",
						"member": {}
					},
					"Text": {},
					"TextType": {},
					"VoiceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AudioStream": {
						"type": "blob",
						"streaming": true
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"RequestCharacters": {
						"location": "header",
						"locationName": "x-amzn-RequestCharacters",
						"type": "integer"
					}
				},
				"payload": "AudioStream"
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "string",
			"sensitive": true
		},
		"Si": {
			"type": "structure",
			"members": {
				"Alphabet": {},
				"LanguageCode": {},
				"LastModified": {
					"type": "timestamp"
				},
				"LexiconArn": {},
				"LexemesCount": {
					"type": "integer"
				},
				"Size": {
					"type": "integer"
				}
			}
		}
	}
};

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk_clients_lexruntime__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk_clients_lexruntime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aws_sdk_clients_lexruntime__);






var _class = function () {
  function _class(_ref) {
    var botName = _ref.botName,
        _ref$botAlias = _ref.botAlias,
        botAlias = _ref$botAlias === undefined ? '$LATEST' : _ref$botAlias,
        _ref$user = _ref.user,
        user = _ref$user === undefined ? 'lex' : _ref$user,
        _ref$region = _ref.region,
        region = _ref$region === undefined ? 'us-east-1' : _ref$region,
        credentials = _ref.credentials;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.botName = botName;
    this.botAlias = botAlias;
    this.region = region;
    this.user = user;
    this.credentials = credentials || __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global___default.a.config.credentials;
    this.identityId = this.credentials && 'identityId' in this.credentials ? this.credentials.identityId : this.user;

    this.lexRuntime = new __WEBPACK_IMPORTED_MODULE_3_aws_sdk_clients_lexruntime___default.a({ region: region, credentials: this.credentials });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'refreshCreds',
    value: function refreshCreds() {
      this.lexRuntime.config.credentials = __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global___default.a.config.credentials;
    }
  }, {
    key: 'postText',
    value: function postText(inputText) {
      var sessionAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.refreshCreds();
      var postTextReq = this.lexRuntime.postText({
        botAlias: this.botAlias,
        botName: this.botName,
        inputText: inputText,
        sessionAttributes: sessionAttributes,
        userId: this.identityId });

      return postTextReq.promise();
    }
  }, {
    key: 'postContent',
    value: function postContent(blob) {
      var sessionAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var acceptFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'audio/ogg';
      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      var mediaType = blob.type;
      var contentType = mediaType;
      this.refreshCreds();

      if (mediaType.startsWith('audio/wav')) {
        contentType = 'audio/x-l16; sample-rate=16000; channel-count=1';
      } else if (mediaType.startsWith('audio/ogg')) {
        contentType = 'audio/x-cbr-opus-with-preamble; bit-rate=32000;' + (' frame-size-milliseconds=20; preamble-size=' + offset);
      } else {
        console.warn('unknown media type in lex client');
      }

      var postContentReq = this.lexRuntime.postContent({
        accept: acceptFormat,
        botAlias: this.botAlias,
        botName: this.botName,
        contentType: contentType,
        inputStream: blob,
        sessionAttributes: sessionAttributes,
        userId: this.identityId });

      return postContentReq.promise();
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-11-28",
		"endpointPrefix": "runtime.lex",
		"jsonVersion": "1.1",
		"protocol": "rest-json",
		"serviceFullName": "Amazon Lex Runtime Service",
		"signatureVersion": "v4",
		"signingName": "lex",
		"uid": "runtime.lex-2016-11-28"
	},
	"operations": {
		"PostContent": {
			"http": {
				"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/content"
			},
			"input": {
				"type": "structure",
				"required": [
					"botName",
					"botAlias",
					"userId",
					"contentType",
					"inputStream"
				],
				"members": {
					"botName": {
						"location": "uri",
						"locationName": "botName"
					},
					"botAlias": {
						"location": "uri",
						"locationName": "botAlias"
					},
					"userId": {
						"location": "uri",
						"locationName": "userId"
					},
					"sessionAttributes": {
						"jsonvalue": true,
						"location": "header",
						"locationName": "x-amz-lex-session-attributes"
					},
					"contentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"accept": {
						"location": "header",
						"locationName": "Accept"
					},
					"inputStream": {
						"shape": "S8"
					}
				},
				"payload": "inputStream"
			},
			"output": {
				"type": "structure",
				"members": {
					"contentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"intentName": {
						"location": "header",
						"locationName": "x-amz-lex-intent-name"
					},
					"slots": {
						"jsonvalue": true,
						"location": "header",
						"locationName": "x-amz-lex-slots"
					},
					"sessionAttributes": {
						"jsonvalue": true,
						"location": "header",
						"locationName": "x-amz-lex-session-attributes"
					},
					"message": {
						"location": "header",
						"locationName": "x-amz-lex-message"
					},
					"dialogState": {
						"location": "header",
						"locationName": "x-amz-lex-dialog-state"
					},
					"slotToElicit": {
						"location": "header",
						"locationName": "x-amz-lex-slot-to-elicit"
					},
					"inputTranscript": {
						"location": "header",
						"locationName": "x-amz-lex-input-transcript"
					},
					"audioStream": {
						"shape": "S8"
					}
				},
				"payload": "audioStream"
			},
			"authtype": "v4-unsigned-body"
		},
		"PostText": {
			"http": {
				"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/text"
			},
			"input": {
				"type": "structure",
				"required": [
					"botName",
					"botAlias",
					"userId",
					"inputText"
				],
				"members": {
					"botName": {
						"location": "uri",
						"locationName": "botName"
					},
					"botAlias": {
						"location": "uri",
						"locationName": "botAlias"
					},
					"userId": {
						"location": "uri",
						"locationName": "userId"
					},
					"sessionAttributes": {
						"shape": "Se"
					},
					"inputText": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"intentName": {},
					"slots": {
						"shape": "Se"
					},
					"sessionAttributes": {
						"shape": "Se"
					},
					"message": {},
					"dialogState": {},
					"slotToElicit": {},
					"responseCard": {
						"type": "structure",
						"members": {
							"version": {},
							"contentType": {},
							"genericAttachments": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"title": {},
										"subTitle": {},
										"attachmentLinkUrl": {},
										"imageUrl": {},
										"buttons": {
											"type": "list",
											"member": {
												"type": "structure",
												"required": [
													"text",
													"value"
												],
												"members": {
													"text": {},
													"value": {}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	},
	"shapes": {
		"S8": {
			"type": "blob",
			"streaming": true
		},
		"Se": {
			"type": "map",
			"key": {},
			"value": {}
		}
	}
};

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_worker_loader_wav_worker__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_worker_loader_wav_worker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_worker_loader_wav_worker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_webrtc_adapter__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_webrtc_adapter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_webrtc_adapter__);










var _class = function () {
  function _class() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.initOptions(options);

    this._eventTarget = document.createDocumentFragment();

    this._encoderWorker = new __WEBPACK_IMPORTED_MODULE_5_worker_loader_wav_worker___default.a();

    this._encoderWorker.addEventListener('message', function (evt) {
      return _this._exportWav(evt.data);
    });
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'initOptions',
    value: function initOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.preset) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(options, this._getPresetOptions(options.preset));
      }

      this.mimeType = options.mimeType || 'audio/wav';

      this.recordingTimeMax = options.recordingTimeMax || 8;
      this.recordingTimeMin = options.recordingTimeMin || 2;
      this.recordingTimeMinAutoIncrease = typeof options.recordingTimeMinAutoIncrease !== 'undefined' ? !!options.recordingTimeMinAutoIncrease : true;

      this.autoStopRecording = typeof options.autoStopRecording !== 'undefined' ? !!options.autoStopRecording : true;
      this.quietThreshold = options.quietThreshold || 0.001;
      this.quietTimeMin = options.quietTimeMin || 0.4;
      this.volumeThreshold = options.volumeThreshold || -75;

      this.useBandPass = typeof options.useBandPass !== 'undefined' ? !!options.useBandPass : true;

      this.bandPassFrequency = options.bandPassFrequency || 4000;

      this.bandPassQ = options.bandPassQ || 0.707;

      this.bufferLength = options.bufferLength || 2048;
      this.numChannels = options.numChannels || 1;

      this.requestEchoCancellation = typeof options.requestEchoCancellation !== 'undefined' ? !!options.requestEchoCancellation : true;

      this.useAutoMuteDetect = typeof options.useAutoMuteDetect !== 'undefined' ? !!options.useAutoMuteDetect : true;
      this.muteThreshold = options.muteThreshold || 1e-7;

      this.encoderUseTrim = typeof options.encoderUseTrim !== 'undefined' ? !!options.encoderUseTrim : true;
      this.encoderQuietTrimThreshold = options.encoderQuietTrimThreshold || 0.0008;
      this.encoderQuietTrimSlackBack = options.encoderQuietTrimSlackBack || 4000;
    }
  }, {
    key: '_getPresetOptions',
    value: function _getPresetOptions() {
      var preset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'low_latency';

      this._presets = ['low_latency', 'speech_recognition'];

      if (this._presets.indexOf(preset) === -1) {
        console.error('invalid preset');
        return {};
      }

      var presets = {
        low_latency: {
          encoderUseTrim: true,
          useBandPass: true
        },
        speech_recognition: {
          encoderUseTrim: false,
          useBandPass: false,
          useAutoMuteDetect: false
        }
      };

      return presets[preset];
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      this._state = 'inactive';

      this._instant = 0.0;
      this._slow = 0.0;
      this._clip = 0.0;
      this._maxVolume = -Infinity;

      this._isMicQuiet = true;
      this._isMicMuted = false;

      this._isSilentRecording = true;
      this._silentRecordingConsecutiveCount = 0;

      return this._initAudioContext().then(function () {
        return _this2._initMicVolumeProcessor();
      }).then(function () {
        return _this2._initStream();
      });
    }
  }, {
    key: 'start',
    value: function start() {
      if (this._state !== 'inactive' || typeof this._stream === 'undefined') {
        console.warn('recorder start called out of state');
        return;
      }

      this._state = 'recording';

      this._recordingStartTime = this._audioContext.currentTime;
      this._eventTarget.dispatchEvent(new Event('start'));

      this._encoderWorker.postMessage({
        command: 'init',
        config: {
          sampleRate: this._audioContext.sampleRate,
          numChannels: this.numChannels,
          useTrim: this.encoderUseTrim,
          quietTrimThreshold: this.encoderQuietTrimThreshold,
          quietTrimSlackBack: this.encoderQuietTrimSlackBack
        }
      });
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this._state !== 'recording') {
        console.warn('recorder stop called out of state');
        return;
      }

      if (this._recordingStartTime > this._quietStartTime) {
        this._isSilentRecording = true;
        this._silentRecordingConsecutiveCount += 1;
        this._eventTarget.dispatchEvent(new Event('silentrecording'));
      } else {
        this._isSilentRecording = false;
        this._silentRecordingConsecutiveCount = 0;
        this._eventTarget.dispatchEvent(new Event('unsilentrecording'));
      }

      this._state = 'inactive';
      this._recordingStartTime = 0;

      this._encoderWorker.postMessage({
        command: 'exportWav',
        type: 'audio/wav'
      });

      this._eventTarget.dispatchEvent(new Event('stop'));
    }
  }, {
    key: '_exportWav',
    value: function _exportWav(evt) {
      this._eventTarget.dispatchEvent(new CustomEvent('dataavailable', { detail: evt.data }));
      this._encoderWorker.postMessage({ command: 'clear' });
    }
  }, {
    key: '_recordBuffers',
    value: function _recordBuffers(inputBuffer) {
      if (this._state !== 'recording') {
        console.warn('recorder _recordBuffers called out of state');
        return;
      }
      var buffer = [];
      for (var i = 0; i < inputBuffer.numberOfChannels; i++) {
        buffer[i] = inputBuffer.getChannelData(i);
      }

      this._encoderWorker.postMessage({
        command: 'record',
        buffer: buffer
      });
    }
  }, {
    key: '_setIsMicMuted',
    value: function _setIsMicMuted() {
      if (!this.useAutoMuteDetect) {
        return;
      }

      if (this._instant >= this.muteThreshold) {
        if (this._isMicMuted) {
          this._isMicMuted = false;
          this._eventTarget.dispatchEvent(new Event('unmute'));
        }
        return;
      }

      if (!this._isMicMuted && this._slow < this.muteThreshold) {
        this._isMicMuted = true;
        this._eventTarget.dispatchEvent(new Event('mute'));
        console.info('mute - instant: %s - slow: %s - track muted: %s', this._instant, this._slow, this._tracks[0].muted);

        if (this._state === 'recording') {
          this.stop();
          console.info('stopped recording on _setIsMicMuted');
        }
      }
    }
  }, {
    key: '_setIsMicQuiet',
    value: function _setIsMicQuiet() {
      var now = this._audioContext.currentTime;

      var isMicQuiet = this._maxVolume < this.volumeThreshold || this._slow < this.quietThreshold;

      if (!this._isMicQuiet && isMicQuiet) {
        this._quietStartTime = this._audioContext.currentTime;
        this._eventTarget.dispatchEvent(new Event('quiet'));
      }

      if (this._isMicQuiet && !isMicQuiet) {
        this._quietStartTime = 0;
        this._eventTarget.dispatchEvent(new Event('unquiet'));
      }
      this._isMicQuiet = isMicQuiet;

      var recordingTimeMin = this.recordingTimeMinAutoIncrease ? this.recordingTimeMin - 1 + Math.pow(this.recordingTimeMax, 1 - 1 / (this._silentRecordingConsecutiveCount + 1)) : this.recordingTimeMin;

      if (this.autoStopRecording && this._isMicQuiet && this._state === 'recording' && now - this._recordingStartTime > recordingTimeMin && now - this._quietStartTime > this.quietTimeMin) {
        this.stop();
      }
    }
  }, {
    key: '_initAudioContext',
    value: function _initAudioContext() {
      var _this3 = this;

      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!window.AudioContext) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('Web Audio API not supported.');
      }
      this._audioContext = new AudioContext();
      document.addEventListener('visibilitychange', function () {
        console.info('visibility change triggered in recorder. hidden:', document.hidden);
        if (document.hidden) {
          _this3._audioContext.suspend();
        } else {
          _this3._audioContext.resume();
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    }
  }, {
    key: '_initMicVolumeProcessor',
    value: function _initMicVolumeProcessor() {
      var _this4 = this;

      var processor = this._audioContext.createScriptProcessor(this.bufferLength, this.numChannels, this.numChannels);
      processor.onaudioprocess = function (evt) {
        if (_this4._state === 'recording') {
          _this4._recordBuffers(evt.inputBuffer);

          if (_this4._audioContext.currentTime - _this4._recordingStartTime > _this4.recordingTimeMax) {
            console.warn('stopped recording due to maximum time');
            _this4.stop();
          }
        }

        var input = evt.inputBuffer.getChannelData(0);
        var sum = 0.0;
        var clipCount = 0;
        for (var i = 0; i < input.length; ++i) {
          sum += input[i] * input[i];
          if (Math.abs(input[i]) > 0.99) {
            clipCount += 1;
          }
        }
        _this4._instant = Math.sqrt(sum / input.length);
        _this4._slow = 0.95 * _this4._slow + 0.05 * _this4._instant;
        _this4._clip = input.length ? clipCount / input.length : 0;

        _this4._setIsMicMuted();
        _this4._setIsMicQuiet();

        _this4._analyser.getFloatFrequencyData(_this4._analyserData);
        _this4._maxVolume = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this4._analyserData));
      };

      this._micVolumeProcessor = processor;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    }
  }, {
    key: '_initStream',
    value: function _initStream() {
      var _this5 = this;

      var constraints = {
        audio: {
          optional: [{
            echoCancellation: this.requestEchoCancellation
          }]
        }
      };

      return navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
        _this5._stream = stream;

        _this5._tracks = stream.getAudioTracks();
        console.info('using media stream track labeled: ', _this5._tracks[0].label);

        _this5._tracks[0].onmute = _this5._setIsMicMuted;
        _this5._tracks[0].onunmute = _this5._setIsMicMuted;

        var source = _this5._audioContext.createMediaStreamSource(stream);
        var gainNode = _this5._audioContext.createGain();
        var analyser = _this5._audioContext.createAnalyser();

        if (_this5.useBandPass) {
          var biquadFilter = _this5._audioContext.createBiquadFilter();
          biquadFilter.type = 'bandpass';

          biquadFilter.frequency.value = _this5.bandPassFrequency;
          biquadFilter.gain.Q = _this5.bandPassQ;

          source.connect(biquadFilter);
          biquadFilter.connect(gainNode);
          analyser.smoothingTimeConstant = 0.5;
        } else {
          source.connect(gainNode);
          analyser.smoothingTimeConstant = 0.9;
        }
        analyser.fftSize = _this5.bufferLength;
        analyser.minDecibels = -90;
        analyser.maxDecibels = -30;

        gainNode.connect(analyser);
        analyser.connect(_this5._micVolumeProcessor);
        _this5._analyserData = new Float32Array(analyser.frequencyBinCount);
        _this5._analyser = analyser;

        _this5._micVolumeProcessor.connect(_this5._audioContext.destination);

        _this5._eventTarget.dispatchEvent(new Event('streamReady'));
      });
    }
  }, {
    key: 'state',
    get: function get() {
      return this._state;
    }
  }, {
    key: 'stream',
    get: function get() {
      return this._stream;
    }
  }, {
    key: 'isMicQuiet',
    get: function get() {
      return this._isMicQuiet;
    }
  }, {
    key: 'isMicMuted',
    get: function get() {
      return this._isMicMuted;
    }
  }, {
    key: 'isSilentRecording',
    get: function get() {
      return this._isSilentRecording;
    }
  }, {
    key: 'isRecording',
    get: function get() {
      return this._state === 'recording';
    }
  }, {
    key: 'volume',
    get: function get() {
      return {
        instant: this._instant,
        slow: this._slow,
        clip: this._clip,
        max: this._maxVolume
      };
    }
  }, {
    key: 'onstart',
    set: function set(cb) {
      this._eventTarget.addEventListener('start', cb);
    }
  }, {
    key: 'onstop',
    set: function set(cb) {
      this._eventTarget.addEventListener('stop', cb);
    }
  }, {
    key: 'ondataavailable',
    set: function set(cb) {
      this._eventTarget.addEventListener('dataavailable', cb);
    }
  }, {
    key: 'onerror',
    set: function set(cb) {
      this._eventTarget.addEventListener('error', cb);
    }
  }, {
    key: 'onstreamready',
    set: function set(cb) {
      this._eventTarget.addEventListener('streamready', cb);
    }
  }, {
    key: 'onmute',
    set: function set(cb) {
      this._eventTarget.addEventListener('mute', cb);
    }
  }, {
    key: 'onunmute',
    set: function set(cb) {
      this._eventTarget.addEventListener('unmute', cb);
    }
  }, {
    key: 'onsilentrecording',
    set: function set(cb) {
      this._eventTarget.addEventListener('silentrecording', cb);
    }
  }, {
    key: 'onunsilentrecording',
    set: function set(cb) {
      this._eventTarget.addEventListener('unsilentrecording', cb);
    }
  }, {
    key: 'onquiet',
    set: function set(cb) {
      this._eventTarget.addEventListener('quiet', cb);
    }
  }, {
    key: 'onunquiet',
    set: function set(cb) {
      this._eventTarget.addEventListener('unquiet', cb);
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
	return new Worker(__webpack_require__.p + "90792a326a0b1f5cf518.worker.js");
};

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);




var initRecorderHandlers = function initRecorderHandlers(context) {

  context.state.recorder.onstart = function () {
    console.info('recorder start event triggered');
    console.time('recording time');
  };
  context.state.recorder.onstop = function () {
    context.dispatch('stopRecording');
    console.timeEnd('recording time');
    console.time('recording processing time');
    console.info('recorder stop event triggered');
  };
  context.state.recorder.onsilentrecording = function () {
    console.info('recorder silent recording triggered');
    context.commit('increaseSilentRecordingCount');
  };
  context.state.recorder.onunsilentrecording = function () {
    if (context.state.recState.silentRecordingCount > 0) {
      context.commit('resetSilentRecordingCount');
    }
  };
  context.state.recorder.onerror = function (e) {
    console.error('recorder onerror event triggered', e);
  };
  context.state.recorder.onstreamready = function () {
    console.info('recorder stream ready event triggered');
  };
  context.state.recorder.onmute = function () {
    console.info('recorder mute event triggered');
    context.commit('setIsMicMuted', true);
  };
  context.state.recorder.onunmute = function () {
    console.info('recorder unmute event triggered');
    context.commit('setIsMicMuted', false);
  };
  context.state.recorder.onquiet = function () {
    console.info('recorder quiet event triggered');
    context.commit('setIsMicQuiet', true);
  };
  context.state.recorder.onunquiet = function () {
    console.info('recorder unquiet event triggered');
    context.commit('setIsMicQuiet', false);
  };

  context.state.recorder.ondataavailable = function (e) {
    var mimeType = context.state.recorder.mimeType;
    console.info('recorder data available event triggered');
    var audioBlob = new Blob([e.detail], { type: mimeType });

    var offset = 0;

    if (mimeType.startsWith('audio/ogg')) {
      offset = 125 + e.detail[125] + 1;
    }
    console.timeEnd('recording processing time');

    context.dispatch('lexPostContent', audioBlob, offset).then(function (lexAudioBlob) {
      if (context.state.recState.silentRecordingCount >= context.state.config.converser.silentConsecutiveRecordingMax) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('Too many consecutive silent recordings: ' + (context.state.recState.silentRecordingCount + '.'));
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([context.dispatch('getAudioUrl', audioBlob), context.dispatch('getAudioUrl', lexAudioBlob)]);
    }).then(function (audioUrls) {
      if (context.state.lex.dialogState !== 'Fulfilled' && !context.state.recState.isConversationGoing) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }

      var _audioUrls = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(audioUrls, 2),
          humanAudioUrl = _audioUrls[0],
          lexAudioUrl = _audioUrls[1];

      context.dispatch('pushMessage', {
        type: 'human',
        audio: humanAudioUrl,
        text: context.state.lex.inputTranscript
      });
      context.dispatch('pushMessage', {
        type: 'bot',
        audio: lexAudioUrl,
        text: context.state.lex.message,
        dialogState: context.state.lex.dialogState,
        responseCard: context.state.lex.responseCard
      });
      return context.dispatch('playAudio', lexAudioUrl, {}, offset);
    }).then(function () {
      if (['Fulfilled', 'ReadyForFulfillment', 'Failed'].indexOf(context.state.lex.dialogState) >= 0) {
        return context.dispatch('stopConversation').then(function () {
          return context.dispatch('reInitBot');
        });
      }

      if (context.state.recState.isConversationGoing) {
        return context.dispatch('startRecording');
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    }).catch(function (error) {
      console.error('converser error:', error);
      context.dispatch('stopConversation');
      context.dispatch('pushErrorMessage', 'I had an error. ' + error);
      context.commit('resetSilentRecordingCount');
    });
  };
};
/* harmony default export */ __webpack_exports__["a"] = (initRecorderHandlers);

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);





var toolbarLogoRequire = __webpack_require__(425);
var toolbarLogoRequireKey = toolbarLogoRequire.keys().pop();

var toolbarLogo = toolbarLogoRequireKey ? toolbarLogoRequire(toolbarLogoRequireKey) : __webpack_require__(426);

var favIconRequire = __webpack_require__(427);
var favIconRequireKey = favIconRequire.keys().pop();
var favIcon = favIconRequireKey ? favIconRequire(favIconRequireKey) : toolbarLogo;

var envShortName = ['dev', 'prod', 'test'].find(function (env) {
  return "production".startsWith(env);
});

if (!envShortName) {
  console.error('unknown environment in config: ', "production");
}

var configEnvFile = __webpack_require__(428)("./config." + envShortName + '.json');

var configDefault = {
  region: 'us-east-1',

  cognito: {
    poolId: ''
  },

  lex: {
    botName: 'WebUiOrderFlowers',

    botAlias: '$LATEST',

    initialText: 'You can ask me for help ordering flowers. ' + 'Just type "order flowers" or click on the mic and say it.',

    initialSpeechInstruction: 'Say "Order Flowers" to get started',

    sessionAttributes: {},

    reInitSessionAttributesOnRestart: true,

    enablePlaybackInterrupt: false,

    playbackInterruptVolumeThreshold: -60,

    playbackInterruptLevelThreshold: 0.0075,

    playbackInterruptNoiseThreshold: -75,

    playbackInterruptMinDuration: 2
  },

  polly: {
    voiceId: 'Joanna'
  },

  ui: {
    pageTitle: 'Order Flowers Bot',

    parentOrigin: '',

    textInputPlaceholder: 'Type here',

    toolbarColor: 'red',

    toolbarTitle: 'Order Flowers',

    toolbarLogo: toolbarLogo,

    favIcon: favIcon,

    pushInitialTextOnRestart: true,

    reInitSessionAttributesOnRestart: false,

    convertUrlToLinksInBotMessages: true,

    stripTagsFromBotMessages: true
  },

  recorder: {
    enable: true,

    recordingTimeMax: 10,

    recordingTimeMin: 2.5,

    quietThreshold: 0.002,

    quietTimeMin: 0.3,

    volumeThreshold: -65,

    useAutoMuteDetect: false
  },

  converser: {
    silentConsecutiveRecordingMax: 3
  }
};

function getUrlQueryParams(url) {
  try {
    return url.split('?', 2).slice(1, 2).reduce(function (params, queryString) {
      return queryString.split('&');
    }, []).map(function (params) {
      return params.split('=');
    }).reduce(function (queryObj, param) {
      var _param = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(param, 2),
          key = _param[0],
          _param$ = _param[1],
          value = _param$ === undefined ? true : _param$;

      var paramObj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, key, decodeURIComponent(value));
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, queryObj, paramObj);
    }, {});
  } catch (e) {
    console.error('error obtaining URL query parameters', e);
    return {};
  }
}

function getConfigFromQuery(query) {
  try {
    return query.config ? JSON.parse(query.config) : {};
  } catch (e) {
    console.error('error parsing config from URL query', e);
    return {};
  }
}

function mergeConfig(configBase, configSrc) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(configBase).map(function (key) {
    var value = key in configSrc ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, configBase[key], configSrc[key]) : configBase[key];
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, key, value);
  }).reduce(function (merged, configItem) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, merged, configItem);
  }, {});
}

var configFromFiles = mergeConfig(configDefault, configEnvFile);
var queryParams = getUrlQueryParams(window.location.href);
var configFromQuery = getConfigFromQuery(queryParams);
if (configFromQuery.ui && configFromQuery.ui.parentOrigin) {
  delete configFromQuery.ui.parentOrigin;
}

var config = mergeConfig(configFromFiles, configFromQuery);

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 425;

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAB4ElEQVRIDeXBz0uTcQDH8c8xLe2SpDVb9AMV7RZCUIdEodAZQrH/oCC65II6FAhu4Oi4sfoPjI6BwU4J/QGKEUQ/NLcYM29pkI/0vJvbHp7vnm19Z0GXXi/pX2GIae5xTn+HWVz2uMT155jANK79o4MeiXlMzySOcVitIkwWF/hIDlOeVcAlS1h2HGIVm08clA23acUt2ZDB5JAmwjgpHEwp2fAQn8OIqriMg+++bDjBNp60DKTxbHFcdozxlYqIDExQscGIWsEVNqmYlIEIFZuMyY4w3/FkZCCDZ5uQbHiEz2FUVYyyi++BbHiKyeEJk0TIsIspJRvu0IqbsqGDNWw+0C47wmRxgXesY1rnPeDykl41xyViROlTGZ0clXiOaV6im06V0U+UGBcVRIyKHHOEVEYE01WV0UuSPBV3FUQU3w5J2lTCLC57fjKjEtp5jIPvuoLoo9YKp1TCEDGmGVQJZ3hLrbOqR55aRQZkYJANaq2pEeYIytGlKrr5QlBCjRBih6AFVZEl6Ac9aowk9aZUwg3qxdUMbawQtKwS3hC0xAE1x2mKBA1zgaACJ/V7DJCjVoIktT7TLzu6WMC0yGtMLziiVjHFMp4CRTxLXNN+MUyCRQp8Y4sCr4hzXv+jX+Z26XqyE0SfAAAAAElFTkSuQmCC"

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 427;

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./config.dev.json": 429,
	"./config.prod.json": 430
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

module.exports = {
	"cognito": {
		"poolId": "us-east-1:f3383568-a45b-4b65-9a93-d8a4dc582c76"
	},
	"lex": {
		"botName": "DHL",
		"initialText": "You can ask me for help ordering flowers. Just type \"order flowers\" or click on the mic and say it.",
		"initialSpeechInstruction": "Say 'Order Flowers' to get started."
	},
	"polly": {
		"voiceId": "Salli"
	},
	"recorder": {
		"preset": "speech_recognition"
	},
	"ui": {
		"parentOrigin": "http://localhost:8080",
		"pageTitle": "Order Flowers Bot",
		"toolbarTitle": "Order Flowers"
	}
};

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

module.exports = {
	"cognito": {
		"poolId": "us-east-1:f3383568-a45b-4b65-9a93-d8a4dc582c76"
	},
	"lex": {
		"botName": "DHL",
		"initialText": "Welcome to DHL. Just type \"Tracking or Shipping or Get Quote\" or click on the mic and say it.",
		"initialSpeechInstruction": "Say 'Tracking or Shipping or Get Quote' to get started."
	},
	"ui": {
		"parentOrigin": "https://dhl-pipeline-1oylq1kfcgpix-parentpagebucket-kpjlmwcjsmlo.s3.amazonaws.com",
		"pageTitle": "DHL Bot",
		"toolbarTitle": "DHL"
	},
	"polly": {
		"voiceId": "Salli"
	},
	"recorder": {
		"preset": "speech_recognition"
	}
};

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

module.exports = "data:audio/ogg;base64,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"

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports = "data:audio/mpeg;base64,//uQxAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAACcQCAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA//////////////////////////////////////////////////////////////////8AAAA8TEFNRTMuOTlyBK8AAAAAAAAAADUgJAJxQQABzAAAAnEsm4LsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//sQxAABgAAB/gAAACBLAGZ8AAAEAOAAAHG7///////////qWy3+NQOB//////////+RTEFNRTMuOTkuM1VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVX/+xDEIAOAAAH+AAAAICwAJQwAAARVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVQ=="

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "lex-app",
      "toolbar": ""
    }
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[146]);


// WEBPACK FOOTER //
// static/js/app.346ca07f75e33fa27af2.js